export const UNEXPECTED_ERROR: string =
  "Sorry there has been an unexpected error.";
export const USER_ROLE_API_FAILED: string =
  "The current user has no roles assigned.";
export const IS_AUTHENTICATED_API_FAILED: string =
  "The current users log in state could not be determined.";
export const USER_HAS_NO_FOLDER_PERMISSIONS: string =
  "No folder permissions found for this user - if this Salesforce contact has recently been added to the portal campaign in Salesforce please come back and try again in a few minutes. If you have any queries, please contact the Client Portal Support team.";
